export default "__VITE_ASSET__a3e0e3e5__"